/* Liberty â€” estrelas de avaliaÃ§Ã£o nos cards de produto (home, coleÃ§Ãµes, busca).
   Varre elementos com [data-liberty-pid], busca as mÃ©dias em lote no Supabase
   e injeta um selo de estrelas na posiÃ§Ã£o escolhida no editor de tema. */
(function () {
  var cfg = window.LIBERTY_CARD_STARS || {};
  if (cfg.ativo === false) return;
  if (!cfg.supabaseUrl || !cfg.supabaseKey || !cfg.lojaId) return;

  var POS = cfg.posicao || 'abaixo_titulo'; // abaixo_titulo | acima_titulo | abaixo_preco
  var ZERO = cfg.zeroModo || 'ocultar'; // ocultar | estrelas | convite
  var TEXTO_ZERO = cfg.textoZero || 'Seja o primeiro a avaliar';
  var MOSTRAR_TOTAL = cfg.mostrarTotal !== false;
  var COR = cfg.cor || '#FBBF24';
  var TAM = Number(cfg.tamanho) > 0 ? Number(cfg.tamanho) : 13;
  var cache = {};

  function injectStyles() {
    if (document.getElementById('liberty-card-stars-css')) return;
    var s = document.createElement('style');
    s.id = 'liberty-card-stars-css';
    s.textContent =
      '.liberty-card-stars{display:flex;align-items:center;gap:4px;margin:4px 0;line-height:1;flex-wrap:wrap}' +
      '.liberty-card-stars .lcs-stars{display:inline-flex;align-items:center;gap:2px;color:' + COR + '}' +
      '.liberty-card-stars .lcs-stars svg{width:' + TAM + 'px;height:' + TAM + 'px;display:block}' +
      '.liberty-card-stars .lcs-total{font-size:' + (TAM - 1) + 'px;opacity:.6}';
    document.head.appendChild(s);
  }

  var PATH = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z';

  // cheia = preenchida; vazia = sÃ³ contorno, sem preenchimento
  function starsHtml(media) {
    var n = Math.round(media);
    var out = '';
    for (var i = 1; i <= 5; i++) {
      var cheia = i <= n;
      out += '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="' + PATH + '" fill="' + (cheia ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
        '</svg>';
    }
    return out;
  }

  function visivel(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return (r.width > 0 && r.height > 0) || el.offsetParent !== null;
  }

  // o tema tem blocos duplicados (overlay + conteÃºdo), um deles fica display:none
  function primeiroVisivel(card, seletor) {
    var els = card.querySelectorAll(seletor);
    for (var i = 0; i < els.length; i++) if (visivel(els[i])) return els[i];
    return null;
  }

  function alvo(card) {
    var titulo = primeiroVisivel(card, '.card__heading');
    var preco = primeiroVisivel(card, '.price, .card-information .price');
    if (POS === 'acima_titulo' && titulo) return { node: titulo, onde: 'before' };
    if (POS === 'abaixo_preco' && preco) return { node: preco, onde: 'after' };
    if (titulo) return { node: titulo, onde: 'after' };
    return preco ? { node: preco, onde: 'after' } : null;
  }

  function render(card, dados) {
    if (card.querySelector('.liberty-card-stars')) return;
    var total = dados ? Number(dados.total) || 0 : 0;
    var media = dados ? Number(dados.media) || 0 : 0;
    if (total === 0 && ZERO === 'ocultar') return;
    var a = alvo(card);
    if (!a) { card.removeAttribute('data-liberty-stars-done'); return; }
    var el = document.createElement('div');
    el.className = 'liberty-card-stars';
    el.innerHTML =
      '<span class="lcs-stars" aria-hidden="true">' + starsHtml(media) + '</span>' +
      (total > 0
        ? (MOSTRAR_TOTAL ? '<span class="lcs-total">(' + total + ')</span>' : '')
        : (ZERO === 'convite' ? '<span class="lcs-total">' + TEXTO_ZERO + '</span>' : ''));
    el.setAttribute('aria-label', total > 0 ? media + ' de 5 estrelas, ' + total + ' avaliaÃ§Ãµes' : 'Sem avaliaÃ§Ãµes');
    if (a.onde === 'before') a.node.parentNode.insertBefore(el, a.node);
    else a.node.parentNode.insertBefore(el, a.node.nextSibling);
  }

  async function buscar(ids) {
    var faltando = ids.filter(function (id) { return cache[id] === undefined; });
    if (faltando.length) {
      try {
        var res = await fetch(cfg.supabaseUrl + '/rest/v1/rpc/get_ratings_publicos', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', apikey: cfg.supabaseKey, Authorization: 'Bearer ' + cfg.supabaseKey },
          body: JSON.stringify({ p_loja_id: cfg.lojaId, p_shopify_ids: faltando }),
        });
        var data = await res.json();
        // config do painel Spec Av manda sobre o ajuste do editor de tema
        var pc = (data && data.config) || {};
        if (pc.badge_zero) ZERO = pc.badge_zero === 'espaco' ? 'ocultar' : pc.badge_zero;
        if (pc.mostrar_badge === false) MOSTRAR_TOTAL = false;
        if (pc.mostrar_badge === true) MOSTRAR_TOTAL = true;
        faltando.forEach(function (id) { cache[id] = null; });
        var ratings = (data && data.ratings) || {};
        Object.keys(ratings).forEach(function (id) { cache[String(id)] = ratings[id]; });
      } catch (e) {
        faltando.forEach(function (id) { cache[id] = null; });
      }
    }
  }

  async function processar() {
    var cards = [].slice.call(document.querySelectorAll('[data-liberty-pid]:not([data-liberty-stars-done])'));
    if (!cards.length) return;
    cards.forEach(function (c) { c.setAttribute('data-liberty-stars-done', '1'); });
    var ids = [];
    cards.forEach(function (c) {
      var id = String(c.getAttribute('data-liberty-pid') || '');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    await buscar(ids);
    cards.forEach(function (c) { render(c, cache[String(c.getAttribute('data-liberty-pid'))]); });
  }

  function init() {
    injectStyles();
    processar();
    // seÃ§Ãµes carregadas por AJAX (filtros de coleÃ§Ã£o, quick view, paginaÃ§Ã£o infinita)
    var mo = new MutationObserver(function () {
      clearTimeout(mo._t);
      mo._t = setTimeout(processar, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
